<template lang="html">
  <div class="container__gallery">
    <upload-files-list :model.sync="files" class-name="container__gallery__images"/>
    <draggable
      v-model="images"
      group="people"
      tag="ul"
      ghost-class="ghost"
      draggable=".draggable-item"
      @start="drag=true"
      @end="drag=false"
      class="gallery"
    >
      <li
        v-for="(file, index) in images"
        :key="index"
        :class="['drag-row gallery__file', 'draggable-item']"
        v-if="file.image"
        >
        <i class="fas fa-times-circle delete" @click="removeFile(file, index)"></i>
        <div class="gallery__file__link" @click="showLightBox(index)">
          <span :style="{'background-image': 'url(' + file.image.url_image + ')'}" class="image"></span>
          <span class="d-block text-center">{{ file.image.file_name }}</span>
          <span class="d-block text-center">Abrir</span>
        </div>
      </li>
    </draggable>
    <vue-easy-lightbox
      scrollDisabled
      :visible="visible"
      :imgs="lightboxImage"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
import Events from '_utils/events';
import draggable from 'vuedraggable';
import VueEasyLightbox from 'vue-easy-lightbox';
import { getFileIcon } from '_utils';
import UploadFilesList from './UploadFilesList.vue';
import { _OPEN_CONFIRMATION_ } from '../../modules/product/components/ProductModel';

export default {
  name: 'gallery-images',
  components: {
    draggable,
    UploadFilesList,
    VueEasyLightbox,
  },
  props: {
    model: {
      type: Array,
    },
    deleteEvent: {
      type: String,
      default: _OPEN_CONFIRMATION_,
    },
  },
  data() {
    return {
      visible: false,
      index: 1,
      lightboxImage: '',
      files: [{
        id: null,
        url: null,
        name: null,
        uuid: null,
        type: null,
        size: null,
        url_image: null,
      }],
    };
  },
  computed: {
    images: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      },
    },
  },
  watch: {
    files: {
      handler(values) {
        if (values[0] && values[0].name !== null) {
          this.$emit('uploadFiles', values);
        }
      },
      deep: true,
    },
  },
  methods: {
    removeFile(file) {
      const params = {
        object: file,
        type: 'file',
        message: 'Arquivo deletado com sucesso',
      };
      Events.$emit(this.deleteEvent, params);
    },
    showLightBox(index) {
      this.visible = true;
      this.lightboxImage = this.images.map(file => file.image.url_image);
      this.index = index;
    },
    getIcon(type) {
      return getFileIcon(type);
    },
    handleHide() {
      this.visible = false;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.drag-row {
  padding-top: 10px;
  margin: 0;
  cursor: move;
  .handle {
    padding-right: 10px;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.container__gallery {
  width: 100%;
  &__images {
    width: 50%;
    margin-bottom: 20px;
  }
  .gallery {
    display: flex;
    width: 100%;
    height: 230px;
    background: #f1f1f1;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
    list-style: none;
    padding: 0;
    overflow: scroll;
    &__file {
      padding: 20px 4px 4px;
      position: relative;
      .image {
        display: block;
        width: 200px;
        height: 150px;
        background-color: #000;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
      .delete {
        display: none;
        top: 0px;
        position: absolute;
        right: 0
        ;
      }
      &:hover{
        background: #ebebeb;
        padding-left: 4px;
        cursor: pointer;
        .delete {
          display: inline-block;
        }
      }
    }
  }
}
</style>
